import { getAdminBarHeight } from '../utilities/functions';
import headerFlashinfo from '../partials/header-flashinfo';
import HeaderNavigation from '../partials/header-navigation';

class Header {
    constructor() {
        this.root = document.documentElement;
        this.header = document.querySelector('.header');
        this.headerMain = document.querySelector('.header-main');
    }

    init() {
        if (!this.header) return;
        window.addEventListener('load', this.handleLoad.bind(this));
        window.addEventListener('scrollStart', this.handleScrollStart.bind(this));
        window.addEventListener('scrollEnd', this.handleScrollEnd.bind(this));
        window.addEventListener('resizeEnd', this.handleResizeEnd.bind(this));
    }

    handleLoad() {
        this.update();
    }

    handleScrollStart() {
        this.header.style.removeProperty('transition');
    }

    handleScrollEnd() {
        this.toggleStickyClass();
    }

    handleResizeEnd() {
        this.update();
    }

    toggleStickyClass() {
        if (this.isSticky()) {
            this.addStickyClass();
        } else {
            this.removeStickyClass();
        }
    }

    isSticky() {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;

        return scrollTop > getAdminBarHeight() + this.header.offsetHeight;
    }

    addStickyClass() {
        document.documentElement.dataset.headerIsSticky = true;
        this.header.classList.add('sticky');
    }

    removeStickyClass() {
        document.documentElement.dataset.headerIsSticky = false;
        this.header.classList.remove('sticky');
    }

    setRootHeaderMainHeight() {
        if (!this.headerMain) return;

        this.root.style.setProperty('--header-height', `${this.headerMain.offsetHeight}px`);
    }

    update() {
        this.toggleStickyClass();
        this.setRootHeaderMainHeight();
    }
}

export default {
    init() {
        const header = new Header();
        header.init();

        /* Partials */
        headerFlashinfo.init();
        HeaderNavigation.init();

        window.header = header;
    },
};
